import { get, post } from '../../utils/request';

export const uploadSavedArt = function (vendorId, fileName, frontId) {
  return post(
    '/api/v1/UploadLogo/UploadSavedArt?vendorId=' + vendorId + '&fileName=' + fileName + '&frontId=' + frontId
  );
};

export const getSavedArtListApi = (processType, imprintAreaCode) => {
  return get(`/api/v1/SavedArt/SavedArtList?processType=${processType}&imprintAreaCode=${imprintAreaCode}`);
};
